const { CALL_INTAKE_V2_API } = require('middleware/intakeV2Api');
const { GET_CANDIDATE_SERVICES_REQUEST, GET_CANDIDATE_SERVICES_SUCCESS, GET_CANDIDATE_SERVICES_FAILURE, POST_CANDIDATE_SERVICES_REQUEST, POST_CANDIDATE_SERVICES_SUCCESS, POST_CANDIDATE_SERVICES_FAILURE, UPDATE_CANDIDATE_SERVICES_REQUEST, UPDATE_CANDIDATE_SERVICES_SUCCESS, UPDATE_CANDIDATE_SERVICES_FAILURE, GET_ALL_CANDIDATE_TRIPS_REQUEST, GET_ALL_CANDIDATE_TRIPS_SUCCESS, GET_ALL_CANDIDATE_TRIPS_FAILURE, GET_CANDIDATE_TRIP_REQUEST, GET_CANDIDATE_TRIP_SUCCESS, GET_CANDIDATE_TRIP_FAILURE, POST_CANDIDATE_TRIP_REQUEST, POST_CANDIDATE_TRIP_SUCCESS, POST_CANDIDATE_TRIP_FAILURE, UPDATE_CANDIDATE_TRIP_REQUEST, UPDATE_CANDIDATE_TRIP_SUCCESS, UPDATE_CANDIDATE_TRIP_FAILURE, DELETE_CANDIDATE_TRIP_REQUEST, DELETE_CANDIDATE_TRIP_SUCCESS, DELETE_CANDIDATE_TRIP_FAILURE, GET_COST_ESTIMATES_REQUEST, GET_COST_ESTIMATES_SUCCESS, GET_COST_ESTIMATES_FAILURE, POST_COST_ESTIMATES_REQUEST, POST_COST_ESTIMATES_SUCCESS, POST_COST_ESTIMATES_FAILURE, UPDATE_COST_ESTIMATES_REQUEST, UPDATE_COST_ESTIMATES_SUCCESS, UPDATE_COST_ESTIMATES_FAILURE, GET_TRAVEL_BOOKING_REQUESTS_BY_AUTH_FAILURE, GET_TRAVEL_BOOKING_REQUESTS_BY_AUTH_REQUEST, GET_TRAVEL_BOOKING_REQUESTS_BY_AUTH_SUCCESS, GET_TRAVEL_BOOKING_REQUESTS_BY_TRIP_FAILURE, GET_TRAVEL_BOOKING_REQUESTS_BY_TRIP_REQUEST, GET_TRAVEL_BOOKING_REQUESTS_BY_TRIP_SUCCESS, GET_TRAVEL_BOOKING_REQUESTS_FAILURE, GET_TRAVEL_BOOKING_REQUESTS_REQUEST, GET_TRAVEL_BOOKING_REQUESTS_SUCCESS, POST_TRAVEL_BOOKING_REQUESTS_FAILURE, POST_TRAVEL_BOOKING_REQUESTS_REQUEST, POST_TRAVEL_BOOKING_REQUESTS_SUCCESS, UPDATE_TRAVEL_BOOKING_REQUESTS_FAILURE, UPDATE_TRAVEL_BOOKING_REQUESTS_REQUEST, UPDATE_TRAVEL_BOOKING_REQUESTS_SUCCESS, DELETE_TRAVEL_BOOKING_REQUESTS_FAILURE, DELETE_TRAVEL_BOOKING_REQUESTS_REQUEST, DELETE_TRAVEL_BOOKING_REQUESTS_SUCCESS } = require('../types/canidateTripTypes');


// Candidate Services

export const getCandidateServices = (authorizationId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CANDIDATE_SERVICES_REQUEST, GET_CANDIDATE_SERVICES_SUCCESS, GET_CANDIDATE_SERVICES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/candidateInternService/getByAuthId`,
      method: 'GET',
    },
  };
};


export const postCandidateServices = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CANDIDATE_SERVICES_REQUEST, POST_CANDIDATE_SERVICES_SUCCESS, POST_CANDIDATE_SERVICES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateCandidateServices = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CANDIDATE_SERVICES_REQUEST, UPDATE_CANDIDATE_SERVICES_SUCCESS, UPDATE_CANDIDATE_SERVICES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService',
      method: 'PUT',
      payload: values,
    },
  };
};


// Candidate Trips

export const getCandidateTrips = (serviceId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_CANDIDATE_TRIPS_REQUEST, GET_ALL_CANDIDATE_TRIPS_SUCCESS, GET_ALL_CANDIDATE_TRIPS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/candidateInternTrip/${serviceId}`,
      method: 'GET',
    },
  };
};

export const getCandidateTripById = (tripId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_CANDIDATE_TRIP_REQUEST, GET_CANDIDATE_TRIP_SUCCESS, GET_CANDIDATE_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/candidateInternTrip/getById/${tripId}`,
      method: 'GET',
    },
  };
};


export const postCandidateTrip = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CANDIDATE_TRIP_REQUEST, POST_CANDIDATE_TRIP_SUCCESS, POST_CANDIDATE_TRIP_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService/candidateInternTrip',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateCandidateTrip = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_CANDIDATE_TRIP_REQUEST, UPDATE_CANDIDATE_TRIP_SUCCESS, UPDATE_CANDIDATE_TRIP_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService/candidateInternTrip',
      method: 'PUT',
      payload: values,
    },
  };
};

export const deleteCandidateTrip = (tripId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_CANDIDATE_TRIP_REQUEST, DELETE_CANDIDATE_TRIP_SUCCESS, DELETE_CANDIDATE_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/candidateInternTrip/${tripId}`,
      method: 'DELETE',
    },
  };
};

export const getCostEstimates = (authorizationId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_COST_ESTIMATES_REQUEST, GET_COST_ESTIMATES_SUCCESS, GET_COST_ESTIMATES_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${authorizationId}/costEstimates`,
      method: 'GET',
    },
  };
};


export const postCostEstimates = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_COST_ESTIMATES_REQUEST, POST_COST_ESTIMATES_SUCCESS, POST_COST_ESTIMATES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/costEstimates',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateCostEstimates = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_COST_ESTIMATES_REQUEST, UPDATE_COST_ESTIMATES_SUCCESS, UPDATE_COST_ESTIMATES_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/costEstimates',
      method: 'PUT',
      payload: values,
    },
  };
};

// Travel Booking api calls added 2/26/2025 via AB#1303

export const getTravelBookingRequestsByAuth = (authorizationId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TRAVEL_BOOKING_REQUESTS_BY_AUTH_REQUEST, GET_TRAVEL_BOOKING_REQUESTS_BY_AUTH_SUCCESS, GET_TRAVEL_BOOKING_REQUESTS_BY_AUTH_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/internTrips/${authorizationId}`,
      method: 'GET',
    },
  };
};

export const getTravelBookingRequestsByTrip = (tripId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TRAVEL_BOOKING_REQUESTS_BY_TRIP_REQUEST, GET_TRAVEL_BOOKING_REQUESTS_BY_TRIP_SUCCESS, GET_TRAVEL_BOOKING_REQUESTS_BY_TRIP_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/travelBooking/getByTripId/${tripId}`,
      method: 'GET',
    },
  };
};

export const getTravelBookingRequestsById = (requestId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TRAVEL_BOOKING_REQUESTS_REQUEST, GET_TRAVEL_BOOKING_REQUESTS_SUCCESS, GET_TRAVEL_BOOKING_REQUESTS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/internTrips/getById/${requestId}`,
      method: 'GET',
    },
  };
};


export const postTravelBookingRequest = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_TRAVEL_BOOKING_REQUESTS_REQUEST, POST_TRAVEL_BOOKING_REQUESTS_SUCCESS, POST_TRAVEL_BOOKING_REQUESTS_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService/internTrips',
      method: 'POST',
      payload: values,
    },
  };
};

export const updateTravelBookingRequest = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_TRAVEL_BOOKING_REQUESTS_REQUEST, UPDATE_TRAVEL_BOOKING_REQUESTS_SUCCESS, UPDATE_TRAVEL_BOOKING_REQUESTS_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizations/candidateInternService/internTrips',
      method: 'PUT',
      payload: values,
    },
  };
};

export const deleteTravelBookingRequest = (requestId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_TRAVEL_BOOKING_REQUESTS_REQUEST, DELETE_TRAVEL_BOOKING_REQUESTS_SUCCESS, DELETE_TRAVEL_BOOKING_REQUESTS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/candidateInternService/internTrips/${requestId}`,
      method: 'DELETE',
    },
  };
};
